module.exports = __webpack_public_path__ + "media/images/badges/health-wellness-100-f442e4833109263459bd9edd0ff5a047.svg";